(function() {

    /* Adds the menu open/close toggle button */
    document.addEventListener('DOMContentLoaded', function() {
        var header = document.querySelector('.site-header');
        var menu   = document.querySelector('.site-menu');
        var button = document.createElement( 'button' );
        var icon   = document.createElement( 'span' );
        var text   = document.createTextNode('Menu');

        button.appendChild(icon);
        button.appendChild(text);
        button.classList.add('menu-button');
        icon.classList.add('menu-button-icon');

        // Add the handler for what happens when you click on the button
        button.addEventListener('click', function(e) {
            header.classList.toggle('menu-is-open');
            button.classList.toggle('is-open');
        });

        // Add the button to the header!
        header.insertBefore(button, menu);
    });

})();